import React, { useState, useEffect, useMemo, Suspense } from 'react';
import { motion } from 'framer-motion';
import Seo from '../../components/SeoComponent/Seo';
import { AddProductNews, RetrieveProductNews } from '../../services/ProductNews/productNews';
import { showErrorToast, showSuccessToast } from '../../utils/toastUtils';
import Loader from '../../components/Loader/Loader';
import ReportHeading from '../Components/ReportHeadings/ReportHeadings';
import HeadingTag from '../Components/HeadingComponent/HeadingTag';
import Button from '../Components/ButtonComponent/Button';
import InputWithLabel from '../Components/InputComponent/InputWithLabel';
import ProductNewsEditModal from './ProductNewsEditModal';
import moment from 'moment/moment';
import { FaEdit, FaTrash } from "react-icons/fa";
import { FaEye } from "react-icons/fa";
import { deleteProduct, retrieveProduct } from '../../services/ListProduct/ListProduct';
import SelectWithLabelOption from '../Components/SelectComponent/SelectWithLabelOption';
import ConfirmPopUp from '../../components/Dialog/ConfirmPopup';
import PaginationData from '../../components/PaginationData';

const ProductNews = () => {
  const [selectedId, setSelectedId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [lastPage, setLastPage] = useState(1);
  const [paginationData, setPaginationData] = useState();
  const [productNewsData, setNewsData] = useState([]);
  const [productId, setProductId] = useState('');
  const [isConfirm, setIsConfirm] = useState(false);
  const [productList, setProductList] = useState([]);
  const [formData, setFormData] = useState({
    news: '',
    news_date: '',

  });
  const [errors, setErrors] = useState({});

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleEditClick = (id) => {
    setSelectedId(id);
    setIsModalOpen(true);
  };
  function handleSetPage(page){
    setCurrentPage(page);
}
  useEffect(() => {
    loadProductNews();
  }, [currentPage]);

  const loadProductNews = async (page = currentPage) => {
    setIsLoading(true);
    try {
      const response = await RetrieveProductNews(page);
      setNewsData(response?.data);
      setPaginationData(response?.pagination);
      setCurrentPage(response?.pagination?.current_page);
      setLastPage(response?.pagination?.last_page);
    } catch (error) {
      console.error('Error fetching news:', error);
    } finally {
      setIsLoading(false);
    }
  };


  const validate = (values) => {
    let errors = {};
    if (!values.news) errors.news = 'News is required';
    if (!values.news_date) errors.news_date = 'News Date is required';
    // if (!values.available_product_id) errors.available_product_id = 'Product is required';
    return errors;
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async () => {
    const validationErrors = validate(formData);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    const payload = {
      news: formData.news,
      news_date: formData.news_date,
      available_product_id: productId
    }

    try {
      const response = await AddProductNews(payload);
      if (response?.status.code === 201 || response.status.code === 200) {
        showSuccessToast(response.status.message);
        loadProductNews(); // Reload news if needed
        setFormData({ news: '', news_date: '', available_product_id: '' });
        return;
      } else {

        showErrorToast(response.status.message || 'Failed to Add Product');
      }
    } catch (error) {
      console.error('Error adding Product', error);
      showErrorToast('Failed to Add Product');
    }
  };


  const handleUpdate = () => {
    loadProductNews();
  };


  const retProduct = async () => {
    setIsLoading(true);
    try {
      const response = await retrieveProduct();
      setProductList(response?.data);
  
    } catch (error) {
      console.error("Error Fetching Product:", error);
    } finally {
      setIsLoading(false);
    }
  };
  async function handleDeleteProduct() {
    try {
      setIsLoading(true);
      let response = await deleteProduct(selectedId);
      setIsLoading(false);
      if (response.status.code === 200) {
        setIsConfirm(false);
        loadProductNews();
        setSelectedId(null);
        showSuccessToast(response.message);

      } else {
        showErrorToast(response.message)
      }
    } catch (error) {
      setIsLoading(isLoading)
    }
  }
  const openConfirmPopup = (id) => {
    setSelectedId(id)
    setIsConfirm(true);
    if (isConfirm) return;
  }
  useMemo(() => {
    retProduct();
  }, []);


  return (
    <motion.div initial={{ opacity: 0, y: -50 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1.2 }}>
      {isLoading && <Loader />}
      <Seo />
      <div className="mt-5 bg-white p-2">
        <ReportHeading name="Product News" />
        {/* Form Section */}
        <ConfirmPopUp visible={isConfirm} onClose={() => setIsConfirm(false)} onConfirm={() => handleDeleteProduct()} title={'Are You sure want to delete product news?'} />

        <div className="flex flex-col md:flex-row justify-center gap-2">

          <InputWithLabel
            label="Enter Product News"
            DivclassName="w-full md:w-1/4"
            name="news"
            placeholder="Enter Product News"
            value={formData.news}
            onChange={handleChange}
            error={errors.news}
          />

          <InputWithLabel
            DivclassName="w-full md:w-1/4"
            label="Select News Date"
            name="news_date"
            type="date"
            value={formData.news_date}
            onChange={handleChange}
            error={errors.news_date}
          />

          <SelectWithLabelOption
            DivclassName="w-full md:w-1/4"
            label="Select Available Product ID"
            id="available_product_id"
            name="available_product_id"
            value={productId}
            onChange={(e) => setProductId(e.target.value)}
          >
            <option value="" disabled>
              Select Product ID
            </option>
            {productList.length > 0
              ? productList.map((value, index) => (
                <option key={index} value={value.id}>
                  {value.name}
                </option>
              ))
              : ""}
          </SelectWithLabelOption>

        </div>

        <div className="flex justify-center mt-2">
          <Button
            className="text-center text-white bg-blue-700 shadow-lg bg-gradient-to-r from-blue-900
                         via-teal-400 to-purple-900 font-semibold p-0 rounded-md px-2 py-1 text-lg hover:bg-red-300"
            type="button"
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </div>
        {/* Report Section */}
        <HeadingTag className="text-2xl text-blue-800 font-bold bg-white text-center mt-2" text="Report" />
        <div className="overflow-x-auto my-1 p-1">


          <div className="container mx-auto p-1">
            {/* Desktop Table View */}
            <div className="hidden lg:block">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="text-md">
                  <tr className="bg-blue-800 text-white text-center">
                    <th className="border-2 p-2">S No.</th>
                    <th className="border-2">News</th>
                    <th className="border-2">Avl. Product ID</th>
                    <th className='border-2'>News Date</th>
                    <th className="border-2">Created At</th>
                    <th className="border-2">Updated At</th>
                    <th className="border-2">Edit</th>
                  </tr>
                </thead>
                <tbody className="text-center">
                  {productNewsData?.length > 0 ? (
                    productNewsData.map((item, index) => (
                      <tr
                        key={(currentPage - 1) * (lastPage) + index + 1}
                      >
                        <td className="border shadow-inner p-1">
                          {(currentPage - 1) * (paginationData?.per_page || 0) + index + 1}
                        </td>
                        <td className="border shadow-inner p-1">
                          <div dangerouslySetInnerHTML={{ __html: item.news }} />

                        </td>
                        <td className='border shadow-inner p-1'>
                          {item?.available_product_id}
                        </td>
                        <td className="border shadow-inner p-1">
                          {moment(item?.news_date).format('DD-MM-YYYY')}
                        </td>
                        <td className="border shadow-inner p-1">
                          {moment(item?.created_at).format('DD-MM-YYYY')}
                        </td>
                        <td className="border shadow-inner p-1">
                          {moment(item?.updated_at).format('DD-MM-YYYY')}
                        </td>
                        <td className="border shadow-inner p-1">
                          <div className="flex justify-center gap-2">
                            <FaEdit
                              size={20}
                              onClick={() => handleEditClick(item?.id)}
                              className="text-blue-700 hover:bg-white hover:text-green-600 cursor-pointer"
                            />
                            <FaTrash
                              size={20}
                              onClick={() => openConfirmPopup(item?.id)}
                              className="text-red-700 hover:bg-white hover:text-red-600 cursor-pointer"
                            />
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="px-4 py-2 text-center text-xl">
                        Data Not Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>


            {/* Mobile Card View */}
            <div className="block lg:hidden">
              {productNewsData?.length > 0 ? (
                productNewsData.map((item, index) => (
                  <Suspense>
                    <ReportCardMobile item={item} index={index} currentPage={currentPage} paginationData={paginationData} lastPage={lastPage} handleEditClick={handleEditClick} />
                  </Suspense>))
              ) : (
                <div className="text-center text-xl text-gray-500">Data Not Found</div>
              )}
            </div>
            {/* Mobile ENd */}

          </div>


          {isModalOpen && (
            <ProductNewsEditModal
              isOpen={isModalOpen}
              onClose={() => setIsModalOpen(false)}
              productNewsId={selectedId}
              onUpdate={handleUpdate}

            />
          )}
          <div className="gap-2 mt-3">
            {/* <div className="flex justify-center gap-3">
              <button
                className="py-1 text-xl rounded-md hover:bg-blue-800 px-4 bg-blue-500 text-white border-none cursor-pointer"
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
              >
                Prev
              </button>
              <button
                className="py-1 text-xl rounded-md hover:bg-blue-800 px-4 bg-blue-900 text-white border-none cursor-pointer"
                onClick={() =>
                  setCurrentPage((prev) =>
                    Math.min(prev + 1, paginationData?.last_page || 1)
                  )
                }
                disabled={currentPage === paginationData?.last_page}
              >
                Next
              </button>
              <div className="flex justify-end">
                <p className="text-[17px] font-bold">
                  Page {currentPage} of {paginationData?.last_page || 1}
                </p>
              </div>
            </div> */}
               <div className='flex justify-center my-2'>
                    <PaginationData currentPage={currentPage} lastPage={paginationData?.last_page} handlePage={handleSetPage} />
                </div>
          </div>

        </div>
      </div>
    </motion.div>
  );
};



const ReportCardMobile = ({ item, index, currentPage, paginationData, handleEditClick, lastPage, }) => {
  return (
    <>
      <div
        key={(currentPage - 1) * (lastPage) + index + 1}
        className="border rounded-lg shadow-lg shadow-blue-500 mb-2 p-2 bg-gradient-to-r from-blue-100 via-white to-blue-50 transition-transform transform hover:scale-105"
      >
        {/* S No. */}
        <div className="flex justify-between items-center mb-1">
          <span className="font-bold text-gray-700">S No.:</span>
          <span className="text-blue-700 font-medium">
            {(currentPage - 1) * (paginationData?.per_page || 0) + index + 1}
          </span>
        </div>

        {/* News Date*/}
        <div className="flex justify-between items-center mb-1">
          <span className="font-bold text-gray-700">News Date:</span>
          <span className="text-gray-600">
            {moment(item?.news_date).format('DD-MM-YYYY')}
          </span>
        </div>


        {/* Created At */}
        <div className="flex justify-between items-center mb-1">
          <span className="font-bold text-gray-700">Created At:</span>
          <span className="text-gray-600">
            {moment(item?.created_at).format('DD-MM-YYYY')}
          </span>
        </div>

        {/* Updated At */}
        <div className="flex justify-between items-center">
          <span className="font-bold text-gray-700">Updated At:</span>
          <span className="text-gray-600">
            {moment(item?.updated_at).format('DD-MM-YYYY')}
          </span>
        </div>

        {/* Edit Button */}
        <div className="flex justify-center">
          <button
            onClick={() => handleEditClick(item?.id)}
            className="flex items-center justify-center w-12 h-10 rounded-full bg-blue-700 text-white hover:bg-green-500 transition-all duration-300"
          >
            <FaEdit size={24} />
          </button>
        </div>

        {/* News */}
        <div className="flex justify-between items-center mb-1">
          <span className="font-bold text-gray-700">News:</span>
          <div className="text-gray-800" dangerouslySetInnerHTML={{ __html: item.news }} />
          <FaEye />
        </div>

        <div className='flex justify-between items-center mb-1'>
          <span className='font-bold text-gray-700'>Avl. Product Id</span>
          <span className="text-gray-600">{item?.available_product_id}</span>
        </div>
      </div>
    </>
  )

}

export default ProductNews;


